import React, { useState, useEffect } from 'react';
import { GoogleApiWrapper } from 'google-maps-react';
import LocationForm from "./Components/LocatorHeader";
import MapClass from './Components/Map';
import './App.css';

const App = (props) => {

  const [clientLatitude, setClientLatitude] = useState();
  const [clientLongitude, setClientLongitude] = useState(0);
  const [mapCenter, setMapCenter] = useState(null);
  const [currentZoom, setCurrentZoom] = useState(null);
  const [locationClick, setLocationClick] = useState(0);

  useEffect(() => {  // on app load  
    // get the user's current location for a starting point on the map
    getLocation();
  }, []);

  const getSearchBarLocation = (location) => {  // get new location from the search bar, convert to lat/lng
    const geocoder = new props.google.maps.Geocoder();
    const address = location;
    geocoder.geocode({ address: address }, (results, status) => {
      if (status === 'OK') {
        setLocationClick(true);
        setClientLatitude(results[0].geometry.location.lat())
        setClientLongitude(results[0].geometry.location.lng());
        setMapCenter(results[0].geometry.location.lat() + "," + results[0].geometry.location.lng());
        setCurrentZoom(10);
      } else {
        alert('Location not found');
      };
    });
  };

  const getLocation = () => {  // get clients current location from navigator.geolocation
    let place = "";
    if (window.location.href.includes("/?place=")) {
      place = window.location.href.substring(window.location.href.indexOf("/?place=") + 8, window.location.href.length);
    };

    if (place) {
      const geocoder = new props.google.maps.Geocoder();
      const address = place;
      geocoder.geocode({ address: address }, (results, status) => {
        if (status === 'OK') {
          setLocationClick(true);
          setClientLatitude(results[0].geometry.location.lat())
          setClientLongitude(results[0].geometry.location.lng());
          setMapCenter(results[0].geometry.location.lat() + "," + results[0].geometry.location.lng());
          setCurrentZoom(10);
        } else {
          setClientLatitude(42.89597);
          setClientLongitude(-85.720506);
          setMapCenter(42.89597 + "," + -85.720506);
          setCurrentZoom(4);
        }
      });

    } else {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setClientLatitude(position.coords.latitude);
            setClientLongitude(position.coords.longitude);
            setMapCenter(position.coords.latitude + "," + position.coords.longitude);
            setCurrentZoom(10);
          },
          (error) => {
            console.error('Location not found');
            // if user denies the geolocating, defaults to showing the entire US centered around michigan
            setClientLatitude(42.89597);
            setClientLongitude(-85.720506);
            setMapCenter(42.89597 + "," + -85.720506);
            setCurrentZoom(4);

          });
      } else {
        console.error('Please enable location');
      };
    };
  };

  const getCurrentLocation = (latitude, longitude) => {
    setClientLatitude(latitude);
    setClientLongitude(longitude);
  };

  const getDropDownZoom = (miles) => {   // get the new zoom from the dropdown menu in the header
    let zoom = parseInt(miles);
    setLocationClick(true);
    setCurrentZoom(zoom);
  };

  const renderLocationForm = () => {  // renders Location Form in the header
    return (<LocationForm getSearchBarLocation={getSearchBarLocation} getDropDownZoom={getDropDownZoom} />);
  };

  const resetLocationClick = () => {
    setTimeout(() => {
      setLocationClick(false);
    }, "1000");
  };

  const setClusterClick = (latitude, longitude) => {
    setLocationClick(true);
    setClientLatitude(latitude)
    setClientLongitude(longitude);
  };

  const renderMap = () => {  // renders Map if store data and location are set 
    if (clientLatitude && clientLongitude && mapCenter && currentZoom) {
      return (<MapClass clientLatitude={clientLatitude} clientLongitude={clientLongitude} mapCenter={mapCenter} zoom={currentZoom} locationClick={locationClick} setClusterClick={setClusterClick} resetLocationClick={resetLocationClick} getCurrentLocation={getCurrentLocation} />)
    };
  };

  return (
    <div className="App">
      <div className="total-react-content">
        <div className="store-locator-header">
          {renderLocationForm()}
        </div>
        {renderMap()}
      </div>
    </div>
  );
};

export default GoogleApiWrapper({
  apiKey: "AIzaSyC8IKYRVkq2IGNEkZWiA5JlPSeoFhxZsAo"
})(App);